"use client";

import { createContext, useContext, useEffect, useState } from "react";
import { CustomAppSidebar } from "./custom-app-sidebar";

interface CustomSidebarContextType {
  isOpen: boolean;
  toggle: () => void;
}

const CustomSidebarContext = createContext<CustomSidebarContextType | null>(
  null,
);

export function useCustomSidebar() {
  const context = useContext(CustomSidebarContext);
  if (!context) {
    throw new Error(
      "useCustomSidebar must be used within CustomSidebarProvider",
    );
  }
  return context;
}

export function CustomSidebarLayout({
  children,
  defaultOpen = true,
  session,
}: {
  children: React.ReactNode;
  defaultOpen?: boolean;
  session?: any;
}) {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  const toggle = () => setIsOpen(!isOpen);

  return (
    <CustomSidebarContext.Provider value={{ isOpen, toggle }}>
      <div className="flex h-screen w-screen overflow-hidden">
        {/* Sidebar */}
        <div
          className={`transition-all duration-200 ease-in-out ${isOpen ? "w-64" : "w-0"
            } overflow-hidden flex-shrink-0`}
        >
          <div className="w-64 h-full">
            <CustomAppSidebar session={session} />
          </div>
        </div>

        {/* Main Content */}
        <div className="flex-1 flex flex-col min-w-0 overflow-hidden">
          {children}
        </div>
      </div>
    </CustomSidebarContext.Provider>
  );
}
